import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import Login from "./components/Login";
import Home from "./components/Home";
import Site from "./components/Site";
import Featured from "./components/Featured";
import ProductDetails from "./components/ProductDetails";
import ProductList from "./components/ProductList";
import Register from "./components/Register";
import ConfirmRegister from "./components/ConfirmRegister";
import Profile from "./components/Profile";
import Cart from "./components/Cart";
import Checkout from "./components/Checkout";
import Payment from "./components/Payment";
import PaymentDemo from "./components/PaymentDemo";
import Logout from "./components/Logout";
import Confirm from "./components/Confirm";
import ConfirmEmail from "./components/ConfirmEmail";
import AdminUsers from "./components/admin/AdminUsers";
import UserDetails from "./components/admin/UserDetails";
import AdminHome from "./components/admin/Home";
import AdminOrders from "./components/admin/AdminOrders";
import AdminDecorators from "./components/admin/AdminDecorators";
import AdminPurchaseOrders from "./components/admin/purchaseorders/AdminPurchaseOrders";
import AdminSubsites from "./components/admin/AdminSubsites";
import SubsiteDetails from "./components/admin/SubsiteDetails";
import AdminCatalog from "./components/admin/AdminCatalog";
import AdminContent from "./components/admin/AdminContent";
import AdminShipping from "./components/admin/AdminShipping";
import Catalog from "./components/admin/noncatalog/Catalog";
import AdminCategories from "./components/admin/AdminCategories";
import AdminFeatured from "./components/admin/AdminFeatured";
import AdminCommunication from "./components/admin/AdminCommunication";
import AdminProductDetails from "./components/admin/AdminProductDetails";
import { default as NCProductDetails} from "./components/admin/noncatalog/ProductDetails";
import AdminRoute from "./components/AdminRoute";
import NavRoute from "./components/NavRoute";
import PublicRoute from "./components/PublicRoute";
import AuthRoute from "./components/AuthRoute";
import AuthRetailRoute from "./components/AuthRetailRoute";
import CreditCardForm from "./components/CreditCardForm";
import LogoList from "./components/admin/logo/LogoList";
import ForgotPassword from "./components/ForgotPassword";
import ResetPassword from "./components/ResetPassword";
import Maintenance from "./components/admin/AdminMaintenance";
import ContactUs from "./components/ContactUs";
import AdminUsersBulkEdit from "./components/admin/AdminUsersBulkEdit";
import Status from "./components/admin/AdminStatus";
import AdminClosedPO from "./components/admin/purchaseorders/AdminClosedPO";
import AdminClosedPOList from "./components/admin/purchaseorders/AdminClosedPOList";
import AdminClosedPODetails from "./components/admin/purchaseorders/AdminClosedPODetails";
import AdminPriceCalculation from "./components/admin/AdminPriceCalculation";
import About from "./components/About";
import PrivacyPolicy from "./components/PrivacyPolicy";
import NotFound from "./components/NotFound";
import AdminNewHireKit from "./components/admin/AdminNewHireKit";
import AdminAddProduct from "./components/admin/AdminAddProduct";
import AdminIgniteProducts from "./components/admin/AdminIgniteProducts";
import AdminIgniteInventory from "./components/admin/AdminIgniteInventory";
import AdminReports from "./components/admin/AdminReports";
import PrintItemOrdersReport from "./components/admin/PrintItemOrdersReport";
import AdminRegistrations from "./components/admin/AdminRegistrations";
import AdminSurveys from "./components/admin/AdminSurveys";
import PublicSurvey from "./components/PublicSurvey";
import AdminSandS from "./components/admin/AdminSandS";
import AdminPrintItems from "./components/admin/AdminPrintItems";
import AdminPrintItemForm from "./components/admin/AdminPrintItemForm";
import AdminPrintItemDetails from "./components/admin/AdminPrintItemDetails";
import PrintItemDetails from "./components/PrintItemDetails";
import KitHome from "./components/KitHome";
import NewHireKitHome from "./components/NewHireKitHome";
import RequestRegistration from "./components/RequestRegistration";
import RequestRegistrationSuccess from "./components/RequestRegistrationSuccess";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import SuperAdminRoute from "./components/SuperAdminRoute";
import SuperAdminOrders from "./components/admin/superuser/SuperAdminOrders";
import ShippingAdmin from "./components/admin/superuser/ShippingAdmin";
import SuperAdminUsers from "./components/admin/superuser/SuperAdminUsers";
import SuperUserDetails from "./components/admin/superuser/SuperUserDetails";
import SuperAdminHome from "./components/admin/superuser/SuperAdminHome";
import SuperAdminSurveys from "./components/admin/superuser/SuperAdminSurveys";
import AdminCapabilities from "./components/admin/AdminCapabilities";
import AdminSuperAdmins from "./components/admin/superuser/AdminSuperAdmins";
import AdminUserTitles from "./components/admin/superuser/AdminUserTitles";

const App = () => {
  return (
    <div>
      <GoogleReCaptchaProvider useRecaptchaNet reCaptchaKey={process.env.REACT_APP_RECAPTCHA_KEY}>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicRoute><Home/></PublicRoute>} />
            <Route path="/about" element={<PublicRoute><About/></PublicRoute>} />
            <Route path="/notfound" element={<PublicRoute><NotFound/></PublicRoute>} />
            <Route path="/forgotpassword" element={<PublicRoute><ForgotPassword/></PublicRoute>} />
            <Route path="/resetpassword" element={<PublicRoute><ResetPassword/></PublicRoute>} />
            <Route path="/s/:siteId" element={<Site/>} />
            <Route path="/home" element={<NavRoute><Home/></NavRoute>} />
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/contact" element={<PublicRoute><ContactUs/></PublicRoute>} />
            <Route path="/privacypolicy" element={<PublicRoute><PrivacyPolicy/></PublicRoute>} />
            <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
            <Route path="/requestregistration" element={<PublicRoute><RequestRegistration /></PublicRoute>} />
            <Route path="/requestsuccess" element={<PublicRoute><RequestRegistrationSuccess /></PublicRoute>} />
            <Route path="/confirmreg" element={<PublicRoute><ConfirmRegister /></PublicRoute>} />
            <Route path="/confirmnewreg" element={<PublicRoute><ConfirmRegister new={true}/></PublicRoute>} />
            <Route path="/confirmemail" element={<PublicRoute><ConfirmEmail /></PublicRoute>} />
            <Route path="/logout" element={<NavRoute><Logout /></NavRoute>} />

            <Route path="/featured" element={<AuthRetailRoute><Featured/></AuthRetailRoute>} />
            <Route path="/kithome" element={<AuthRetailRoute><KitHome/></AuthRetailRoute>} />
            <Route path="/newhirekit" element={<AuthRetailRoute><NewHireKitHome/></AuthRetailRoute>} />
            <Route path="/productlist/:categoryId" element={<AuthRetailRoute><ProductList/></AuthRetailRoute>} />
            <Route path="/productlist" element={<AuthRetailRoute><ProductList/></AuthRetailRoute>} />
            <Route path="/product/details/:productId" element={<AuthRetailRoute><ProductDetails /></AuthRetailRoute>} />
            <Route path="/printitem/:printItemId" element={<AuthRetailRoute><PrintItemDetails /></AuthRetailRoute>} />
            <Route path="/cart" element={<AuthRetailRoute><Cart /></AuthRetailRoute>} />
 

            <Route path="/checkout" element={<AuthRoute><Checkout /></AuthRoute>} />
            <Route path="/payment" element={<AuthRoute><Payment /></AuthRoute>} />
            <Route path="/confirm" element={<AuthRoute><Confirm /></AuthRoute>} />
            <Route path="/processcc" element={<AuthRoute><CreditCardForm /></AuthRoute>} />
            <Route path="/profile" element={<AuthRoute><Profile/></AuthRoute>} />

            <Route path="/admin/home" element={<AdminRoute><AdminHome /></AdminRoute>} />
            <Route path="/admin/categories" element={<AdminRoute><AdminCategories /></AdminRoute>} />
            <Route path="/admin/content" element={<AdminRoute><AdminContent /></AdminRoute>} />
            <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
            <Route path="/admin/usersbulk" element={<AdminRoute><AdminUsersBulkEdit /></AdminRoute>} />
            <Route path="/admin/users/:userId" element={<AdminRoute><UserDetails /></AdminRoute>} />
            <Route path="/admin/orders" element={<AdminRoute><AdminOrders /></AdminRoute>} />
            <Route path="/admin/purchaseorders" element={<AdminRoute><AdminPurchaseOrders /></AdminRoute>} />
            <Route path="/admin/subsites" element={<AdminRoute><AdminSubsites /></AdminRoute>} />
            <Route path="/admin/subsite/:subsiteId" element={<AdminRoute><SubsiteDetails /></AdminRoute>} />
            <Route path="/admin/catalog/:categoryId" element={<AdminRoute><AdminCatalog /></AdminRoute>} />
            <Route path="/admin/featured" element={<AdminRoute><AdminFeatured /></AdminRoute>} />
            <Route path="/admin/allcatalog/:categoryId" element={<AdminRoute><Catalog /></AdminRoute>} />
            <Route path="/admin/productlist" element={<AuthRoute><ProductList/></AuthRoute>} />
            <Route path="/admin/product/details/:productId" element={<AdminRoute><AdminProductDetails /></AdminRoute>} />
            <Route path="/admin/allproduct/details/:productId" element={<AdminRoute><NCProductDetails /></AdminRoute>} />
            <Route path="/admin/logos" element={<AdminRoute><LogoList /></AdminRoute>} />
            <Route path="/admin/communications" element={<AdminRoute><AdminCommunication /></AdminRoute>} />
            <Route path="/admin/decorators" element={<AdminRoute><AdminDecorators /></AdminRoute>} />
            <Route path="/admin/shipping" element={<AdminRoute><AdminShipping /></AdminRoute>} />
            <Route path="/admin/pricecalculation" element={<AdminRoute><AdminPriceCalculation /></AdminRoute>} />
            <Route path="/admin/maintenance" element={<AdminRoute><Maintenance /></AdminRoute>} />
            <Route path="/admin/status" element={<AdminRoute><Status /></AdminRoute>} />
            <Route path="/admin/closedpo" element={<AdminRoute><AdminClosedPO /></AdminRoute>} />
            <Route path="/admin/closedpos" element={<AdminRoute><AdminClosedPOList /></AdminRoute>} />
            <Route path="/admin/closedpo/:poId" element={<AdminRoute><AdminClosedPODetails /></AdminRoute>} />
            <Route path="/admin/newhirekits" element={<AdminRoute><AdminNewHireKit /></AdminRoute>} />            
            <Route path="/admin/addproduct" element={<AdminRoute><AdminAddProduct /></AdminRoute>} />
            <Route path="/admin/igniteproducts" element={<AdminRoute><AdminIgniteProducts /></AdminRoute>} />
            <Route path="/admin/ignite/inventory" element={<SuperAdminRoute><AdminIgniteInventory /></SuperAdminRoute>} />
            <Route path="/admin/reports" element={<AdminRoute><AdminReports /></AdminRoute>} />
            <Route path="/admin/printitemreport" element={<AdminRoute><PrintItemOrdersReport /></AdminRoute>} />
            <Route path="/admin/registrations" element={<AdminRoute><AdminRegistrations /></AdminRoute>} />
            <Route path="/admin/surveys" element={<AdminRoute><AdminSurveys /></AdminRoute>} />

            <Route path="/survey/:code" element={<PublicRoute><PublicSurvey /></PublicRoute>} />
            <Route path="/admin/sands" element={<AdminRoute><AdminSandS /></AdminRoute>} />
            <Route path="/admin/printitems" element={<AdminRoute><AdminPrintItems /></AdminRoute>} />
            <Route path="/admin/printitems/add" element={<AdminRoute><AdminPrintItemForm /></AdminRoute>} />
            <Route path="/admin/printitems/edit/:id" element={<AdminRoute><AdminPrintItemForm /></AdminRoute>} />
            <Route path="/admin/printitem/details/:printItemId" element={<AdminRoute><AdminPrintItemDetails /></AdminRoute>} />

            <Route path="/admin/super/home" element={<SuperAdminRoute><SuperAdminHome /></SuperAdminRoute>} />
            <Route path="/admin/super/orders" element={<SuperAdminRoute><SuperAdminOrders /></SuperAdminRoute>} />
            <Route path="/admin/super/shipping" element={<SuperAdminRoute><ShippingAdmin /></SuperAdminRoute>} />
            <Route path="/admin/super/users" element={<SuperAdminRoute><SuperAdminUsers /></SuperAdminRoute>} />
            <Route path="/admin/super/user/:userId" element={<SuperAdminRoute><SuperUserDetails /></SuperAdminRoute>} />
            <Route path="/admin/super/surveys" element={<SuperAdminRoute><SuperAdminSurveys /></SuperAdminRoute>} />
            <Route path="/admin/capabilities" element={<SuperAdminRoute><AdminCapabilities /></SuperAdminRoute>} />
            <Route path="/admin/printitems" element={<SuperAdminRoute><AdminPrintItems /></SuperAdminRoute>} />
            <Route path="/admin/printitems/add" element={<SuperAdminRoute><AdminPrintItemForm /></SuperAdminRoute>} />
            <Route path="/admin/printitems/edit/:id" element={<SuperAdminRoute><AdminPrintItemForm /></SuperAdminRoute>} />
            <Route path="/printitem/:printItemId" element={<AuthRetailRoute><PrintItemDetails /></AuthRetailRoute>} />
            <Route path="/admin/super/admins" element={<SuperAdminRoute><AdminSuperAdmins /></SuperAdminRoute>} />
            <Route path="/admin/super/titles" element={<SuperAdminRoute><AdminUserTitles /></SuperAdminRoute>} />
          </Routes>
          <div style={{paddingBottom: 100}}></div>


        </BrowserRouter>
        </GoogleReCaptchaProvider>
        </div>
  );
};
export default App;